import {API} from "@/middlewares/api";
import {createAsyncThunk} from "@reduxjs/toolkit";

export const loadBiomarkersInformation = createAsyncThunk(
  "biomarkers/loadBiomarkersInformation",
  async ({userId, mustValidateToken = true}, thunkAPI) => {
    try {
      const response = await API(`secure/biomarkers/all-biomarker-information/${userId}`, {
        method: "GET",
        mustValidateToken,
      });

      return thunkAPI.fulfillWithValue(response);
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const loadBiomarkerAverage = createAsyncThunk("biomarkers/loadBiomarkerAverage", async (payload, thunkAPI) => {
  try {
    const response = await API("secure/get-average", {method: "POST", body: payload});

    return thunkAPI.fulfillWithValue(response);
  } catch (err) {
    return thunkAPI.rejectWithValue(err);
  }
});
